import { useTranslation } from 'react-i18next';

import HeroTitle from '../heroTitle'
import { StatsCurve } from './components/Curve'
import { MissionCard } from './components/MissionCard'
import style from './style.module.scss'

const cardOffsets = [0, 90, 180, 270]

export function Mission() {
    const { t } = useTranslation();

    const statsData = t('mission.stats', { returnObjects: true })

    return (
        <section id='why-nexora' className={style["mission"]}>
            <div className={`container ${style['mission__title']}`}>
                <HeroTitle title={t('mission.label')}>
                    {t('mission.title.before')}
                    <span className='accent'>
                        {t('mission.title.accent')}
                    </span>
                    {t('mission.title.after')}
                </HeroTitle>
            </div>

            <div className={style["mission__inner"]}>
                <div className='container'>
                    <div className={style["mission__chart"]}>
                        <StatsCurve />

                        <div className={style["mission__cards"]}>
                            {statsData.map((item, i) => (
                                <div
                                    key={i}
                                    className={style["mission__card-wrap"]}
                                    style={{ '--offset': `${cardOffsets[i]}px` }}
                                >
                                    <MissionCard
                                        value={item.value}
                                        label={item.label}
                                    />
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}